<template>
<div
  v-if="canVerifyObject || canRejectObject"
  :class="{ [curTheme]: true }">
  <button
    v-if="canVerifyObject"
    class="managment-action-btn"
    @click="showVerifyDialog('verifyObj')">
    Подтвердить объект
  </button>
  <button
    v-if="canRejectObject"
    class="managment-action-btn"
    @click="showVerifyDialog('denyObj')">
    Отклонить объект
  </button>

  <el-dialog
    v-if="objData && objDeal"
    class="verification_win"
    :title="title"
    :visible.sync="winOn">
    <div class="obj-title">{{ objData.Title }}</div>
    <div class="block-title">Тип объекта</div>
    <div class="block-content">{{ typeTitle }}</div>
    <div class="block-title">Авторы и правообладатели</div>
    <div class="block-content">
      <div v-for="(o, i) in objData.Authors"
        :key="`obj-author-${i}`">
        <template v-if="o.IsCopyrightHolder">
          <el-tooltip content="Правообладатель" placement="left">
            <div class="copy-right-holder list-el">
              {{ o.Surname }} {{ o.Name }} {{ o.Patronymic}}
            </div>
          </el-tooltip>
        </template>
        <template v-else>
          <div v-if="!o.IsCopyrightHolder" class="list-el">
            {{ o.Surname }} {{ o.Name }} {{ o.Patronymic}}
          </div>
        </template>
      </div>
    </div>
    <div class="block-title">Организации</div>
    <div class="block-content">
      <div v-for="(o, i) in objData.Organizations"
        :key="`obj-org-${i}`">
        <template v-if="o.IsCopyrightHolder">
          <el-tooltip content="Правообладатель" placement="left">
            <div class="copy-right-holder list-el">{{ o.Organization }}</div>
          </el-tooltip>
        </template>
        <template v-else>
          <div v-if="!o.IsCopyrightHolder" class="list-el">
            {{ o.Organization }}
          </div>
        </template>
      </div>
    </div>
    <div class="block-title">Вид лицензии</div>
    <div class="block-content">{{ objDeal.ContractTitle }}</div>
    <div class="block-content">{{ objDeal.ContractDescription }}</div>
    <div class="block-title">Установленные пределы права использования объекта</div>
    <ul class="block-content">
      <li v-for="(o, i) in objData.LicensesTerms"
        :key="`obj-lic-terms-${i}`" class="fo_li">
        {{ licensesTerms[o] }}
      </li>
    </ul>
    <template v-if="objData.LicensesInformation">
      <div class="block-title">Дополнительные лицензионные условия</div>
      <div class="block-content">{{ objData.LicensesInformation }}</div>
    </template>
    <template v-if="action === 'denyObj'">
      <div class="block-title">
        Причина отклонения объекта:
      </div>
      <el-input
        type="textarea"
        :autosize="{ minRows: 2, maxRows: 20 }"
        placeholder="Введите причину..."
        v-model="cause"/>
    </template>
    <div class="block-title">
      Для подтверждения действия введите пароль:
    </div>
    <el-input
      v-model="password"
      type="password"
      clearable
      :disabled="sendingToApi"
      @focus="passwordInputError=false"
      :class="[{'password-has-error': passwordInputError}, 'password-input' ]"
      :key="`password-input`"/>
    <div slot="footer" class="dialog-footer buttons-wrap">
      <button
        :disabled="sendingToApi"
        :class="[{'send-verification-inactive' : sendingToApi}, 'dialog-primary-btn']"
        @click="setObjVerification">
        Подписать
      </button>
      <button
        class="dialog-empty-btn"
        @click="winOn=false">
        Закрыть окно
      </button>
    </div>
  </el-dialog>

</div>
</template>

<script>
// import axios from 'axios';
import axios from 'axios';

export default {

  props: {
    typeTitle: '',
    objData: null,
    objDeal: null,
    licensesTerms: null,
  },

  data() {
    return {
      action: '',
      title: '',
      cause: '',
      password: '',
      winOn: false,
      passwordInputError: false,
      sendingToApi: false,
    };
  },

  mounted() {
    const script = document.createElement('script');
    script.setAttribute('src', '/static/js/jsrsasign-all-min.js');
    document.head.appendChild(script);
  },

  computed: {

    canVerifyObject() {
      if (this.objData
          && this.objData.Transient.Permissions.OBJECT_VERIFY === true) return true;
      return false;
    },

    canRejectObject() {
      if (this.objData
          && this.objData.Transient.Permissions.OBJECT_REJECT === true) return true;
      return false;
    },
  },

  methods: {

    showVerifyDialog(action) {
      if (action === 'verifyObj') {
        this.title = 'Подтверждение сведений';
      } else {
        this.title = 'Отклонить объект';
      }
      this.action = action;
      this.cause = '';
      this.password = '';
      this.sendingToApi = false;
      this.passwordInputError = '';
      this.winOn = true;
    },

    setObjVerification() {
      if (!this.password) {
        this.passwordInputError = true;
        this.$message('Для подтверждения действия введите пароль');
      } else {
        const userData = this.$store.getters['user/getUserData'];
        if (!userData.PrivateKey) {
          this.$message('Для получения доступа к объекту обновите пароль в профиле пользователя');
        } else {
          this.sendingToApi = true;
          axios.post('users/validatePassword', this.password).then(() => {
            if (this.action === 'verifyObj') {
              const vs = {};
              vs.Files = this.objData.Files;
              vs.ObjectId = this.objData.ObjectId;
              vs.Title = this.objData.Title;
              vs.EditorId = this.objData.EditorId;
              vs.Type = this.objData.Type;
              vs.Edits = this.objData.Edits;
              vs.Authors = this.objData.Authors;
              vs.Organizations = this.objData.Organizations;
              vs.CreatedTime = this.objData.CreatedTime;
              const holderSignature =
                window.SignatureCreate(vs, userData.PrivateKey, this.password);
              axios.post(`objects/${this.objData.ObjectId}/signature`, JSON.stringify({ holderSignature })).then(() => {
                this.winOn = false;
                this.$emit('onUpdateVerification');
              }).catch((error) => {
                this.sendingToApi = false;
                this.$message(error.response.data.join(' '));
              });
            } else {
              axios.post(`objects/${this.objData.ObjectId}/reject`, JSON.stringify({ cause: this.cause })).then(() => {
                this.winOn = false;
                this.$emit('onUpdateVerification');
              }).catch((error) => {
                this.sendingToApi = false;
                this.$message(error.response.data.join(' '));
              });
            }
          }).catch((error) => {
            this.sendingToApi = false;
            this.passwordInputError = true;
            this.$message(error.response.data);
          });
        }
      }
    },

  },

};
</script>

<style lang="scss">
.el-dialog {
  max-width: 800px;
  .obj-title {
    font-size: 22px;
    color: #333;
  }
  .block-title {
    font-size: 16px;
    font-weight: 500;
    color: #000;
  }
  .block-content {
    color: #999;
    margin-top: 5px;
    .list-el {
      margin-left: 10px;
      padding-left: 25px;
      margin-bottom: 5px;
    }
    .copy-right-holder {
      background: 0 0 no-repeat url(/static/grx/icons/right-holder.svg);
    }
  }
  .dialog-primary-btn.send-verification-inactive:disabled,
  .dialog-primary-btn.send-verification-inactive:disabled:hover {
    opacity: 0.2;
    cursor: not-allowed;
  }
  .password-input {
    input[type="password"] {
      color:#000;
      background-color: #fff;
    }
    :disabled {
      opacity: 0.3;
    }
  }
  .password-has-error {
    input[type="password"] {
      background: rgba(170, 0, 0, 0.3);
    }
  }
  .block-title {
    padding-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ObjectVerification.vue